import axios, {AxiosInstance} from 'axios'

export default class Fetcher {
  private readonly client: AxiosInstance
  constructor(token: string) {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
      headers: {
        'Content-Type': 'application/json',
        'Origin': window.location.origin,
        'Authorization': token,
      },
      responseType: 'json'
    })
  }
  fetch(): Promise<responseStory> {
    return Promise.all([
      this._fetchStory(),
      this._fetchStoryContents(),
    ]).then(res => {
      const storyResponse = res[0]
      const storyContentsResponse = res[1]
      if (storyResponse?.status === 200 && storyContentsResponse?.status === 200) {
        return {
          info: storyResponse?.data,
          contents: storyContentsResponse?.data
        }
      }
      return Promise.reject(new Error('コンテンツの取得に失敗しました。'))
    })
  }

  _fetchStory() {
    return this.client.get('/story')
  }
  _fetchStoryContents() {
    return this.client.get('/story-content')
  }
}
